// import { UsersStatusSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
});

export default uiSchema;
